import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  cta: {
    id: `navigation_cta`,
  },
  signIn: {
    id: `navigation_log_in_button`,
  },
  languages: {
    id: `navigation_languages_dropdown`,
  },
  courses: {
    id: `navigation_courses_dropdown`,
  },
  allCourses: {
    id: `navigation_all_courses_button`,
  },
  phrasebooks: {
    id: `navigation_phrasebooks_dropdown`,
  },
  blog: {
    id: `navigation_blog_button`,
  },
  menuAriaLabel: {
    id: `scenario_learnable_list_button_see_more`,
  },
  selectPageLanguage: {
    id: 'seo_header_source_language_dropdown',
  },
});
